<template>
  <div>
    <Card>
      <div class="search-con search-con-top">
        <Form :model="form" :label-width="80" inline>
          <FormItem label="账户">
            <Input v-model="form.accountNo"></Input>
          </FormItem>
          <FormItem label="开始日期">
            <DatePicker v-model="form.map.startDay"></DatePicker>
          </FormItem>
          <FormItem label="结束日期">
            <DatePicker v-model="form.map.endDay" :start-date="form.map.startDay"></DatePicker>
          </FormItem>
        </Form>
        <div class="toolbar">
          <Button type="primary" icon="ios-recording" @click="handleExport">导出</Button>
          <Button @click="handleSearch" icon="md-search" class="search-btn" type="primary">搜索</Button>
        </div>
      </div>
      <Tables ref="tables" v-model="tableData" :columns="columns" @on-search="handleSearch"
              @on-update="handleUpdate" @on-detail="handleDetail" @on-selection-change="selectionChange"/>
    </Card>
  </div>
</template>

<script>

import { formatDate } from '@/libs/dateutil'

export default {
  name: 'stat-day-list',
  components: {},
  data () {
    return {
      columns: [
        { title: '账户', key: 'accountNo' },
        { title: '机构', key: 'tenantName' },
        { title: '统计日期', key: 'day' },
        { title: '消费金额', key: 'outMoney' },
        { title: '余额', key: 'balance' },
        { title: '消费次数', key: 'countData' },
        { title: '创建时间', key: 'crtTime' }
      ],
      tableData: {
        rows: [],
        total: 0
      },
      form: {
        type: 1,
        map: {}
      },
      selectedData: [],
      infoIsShow: false
    }
  },
  methods: {
    handleExport () {
      this.form.startDay = formatDate(this.form.map.startDay, 'yyyy-MM-dd')
      this.form.endDay = formatDate(this.form.map.endDay, 'yyyy-MM-dd')
      this.DL('api/trade/accountreconciliation/exportExcel?', this.form)
    },
    selectionChange (selection) {
      this.selectedData = selection
    },
    handleSearch (page, pageSize) {
      if (isNaN(page)) {
        page = 1
      }
      let param = {
        page: page,
        pageSize: pageSize,
        model: this.form,
        map: {
          startDay: formatDate(this.form.map.startDay, 'yyyy-MM-dd'),
          endDay: formatDate(this.form.map.endDay, 'yyyy-MM-dd')
        }
      }
      this.L('trade/accountreconciliation', param).then(data => {
        this.tableData = data
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
